export enum SortType {
  REG_DATE = 'reg_date',
  LAST_DATE = 'last_date',
  TITLE = 'title',
  EXT_TYPE = 'ext_type',
  SHARE_DATE = 'share_date',
  HIT = 'hit',
  ORG_FILE_NAME = 'org_file_name',
  SIZE = 'size',
  DELETE_DATE = 'delete_date',
  UPLOAD_DATE = 'upload_date',
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum UserType {
  TEACHER = 1,
  STUDENT = 2,
}

export interface StringByKey {
  [key: string]: string;
}

export interface ObjectByKey {
  [key: string]: StringByKey;
}

export interface ResponseBody {
  transactionTime: string;
  success: boolean;
  code: string;
  message: string;
  // CHECK: data type
  data: any;
}

export interface Terms {
  seq: number;
  agreeCd: string;
  title: string;
  dispTitle: string;
  content: string;
  requireYn: 0 | 1;
  useYn: 0 | 1;
  startDate: string;
  dispStartDate: string;
  prevYn: 0 | 1;
}

export interface Notification {
  code: string;
  msg: string;
}

export interface ListParams {
  page?: number;
  size?: number;
  search?: string;
  sortDir?: 'ASC' | 'DESC';
  sortBy?: SortType;
  faqCd?: string;
}

export interface Env {
  SELVYPEN_API: string;
  SELVYPEN_KEY: string;
  SELVY_TTS_URL: string;
  EXPIRED_SPEECH: boolean;
  EXPIRED_TTS: boolean;
  EXPIRED_SELVYPEN: boolean;
  EXPIRED_OWNER_SPEECH: boolean;
  EXPIRED_OWNER_TTS: boolean;
  EXPIRED_OWNER_SELVYPEN: boolean;
  SPEECH_SR_DB: string[];
  CSS: string[];
}

export interface Group {
  seq: number;
  groupNm: string;
}
